import { parse } from 'qs'
import { Cookies, setCookie } from './cookies'

export const parseQueryParams = (search: string) =>
  parse(search, { ignoreQueryPrefix: true })

export const addQueryParams = (url: string, query: { [key: string]: string }) => {
  const queryString = new URLSearchParams(
    Object.entries(query)
      .filter(([key, value]) => !!value)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  ).toString()

  if (!queryString) {
    return url
  }
  if (url.includes('?')) {
    return `${url}&${queryString}`
  }
  return `${url}?${queryString}`
}

export const setCookieFromQueryParams = (parsedQueryParams: qs.ParsedQs) => {
  if (parsedQueryParams.enableCLSandbox) {
    setCookie(Cookies.EnableCLSandbox, parsedQueryParams.enableCLSandbox as string)
  }
}



// WEBPACK FOOTER //
// ./src/utils/queryParams.ts